import {
  AppsConfig,
  ResolvedAppConfig,
  StatesMapResult,
} from '../types/login-config.types';

/**
 * Mirrors AppLoginController in mimecast-universal-login login-controller.js.
 * Top-level appsConfig keys are app/json identifiers, not gta values.
 */
export function buildStatesMap(appsConfig: AppsConfig): StatesMapResult {
  const states: Record<string, ResolvedAppConfig> = {};
  let global: ResolvedAppConfig | null = null;
  let defaultStateKey: string | undefined;

  for (const entry of Object.values(appsConfig)) {
    const loginModule = entry['login-module'];
    if (!loginModule) {
      continue;
    }

    const stateKey =
      loginModule.gta || loginModule.partialAppUrl.split('/')[1] || '';

    if (!stateKey) {
      continue;
    }

    const resolved: ResolvedAppConfig = {
      loginModule,
      xMcAppId: entry['x-mc-app-id'] ?? '',
      stateKey,
    };

    states[stateKey] = resolved;

    if (loginModule.isDefaultLoginInThisWebContainer && global === null) {
      global = resolved;
      defaultStateKey = stateKey;
    }
  }

  return { states, global, defaultStateKey };
}
